var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.6667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.067 3.986c-0.094-0.094-0.221-0.148-0.354-0.148v0c-0.133 0-0.26 0.053-0.354 0.147l-10.922 10.925c-0.195 0.195-0.195 0.512 0 0.707l4.948 4.948c0.195 0.195 0.512 0.195 0.707 0l10.917-10.917c0.195-0.195 0.195-0.511 0-0.706l-4.942-4.956zm-12.637 12.814c-0.128-0.128-0.315-0.176-0.489-0.127s-0.308 0.188-0.351 0.364l-1.506 6.277c-0.04 0.169 0.01 0.347 0.133 0.47 0.124 0.121 0.301 0.171 0.47 0.132l6.272-1.5c0.269-0.064 0.434-0.334 0.37-0.603-0.022-0.09-0.068-0.172-0.133-0.237l-4.766-4.776zm20.77-13.876-2.123-2.124c-0.976-0.974-2.556-0.974-3.532 0l-1.418 1.417c-0.195 0.195-0.195 0.512 0 0.707l4.95 4.949c0.195 0.195 0.512 0.195 0.707 0l1.416-1.419c0.973-0.976 0.973-2.554 0-3.53z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cb8a25e1dd2a1f5ec3d44ec46d9f92aa.svg";
export { ForwardRef as ReactComponent };